export const isDefined = <T>(value: T | undefined | null): value is T =>
  value !== null && value !== undefined

export const isNotDefined = <T>(
  value: T | undefined | null
): value is undefined | null => !isDefined(value)

/*
 * Given an array with optional values (null or undefined), return a new array filtered of
 * the optional values and typed as to the non-optional type.
 */
export const defined = <T>(
  values: (T | undefined | null)[] | undefined | null
) => values?.filter(isDefined) ?? []
